import { ShieldCheck, HeartHandshake, PlayCircle, MapPin, BookOpen, Globe2, Heart } from 'lucide-react'

const iconMap: Record<string, React.ReactNode> = {
  'shield-check':   <ShieldCheck  size={24} aria-hidden="true" />,
  'heart-handshake':<HeartHandshake size={24} aria-hidden="true" />,
  'play-circle':    <PlayCircle  size={24} aria-hidden="true" />,
  'map-pin':        <MapPin      size={24} aria-hidden="true" />,
  'book-open':      <BookOpen    size={24} aria-hidden="true" />,
  'globe-2':        <Globe2      size={24} aria-hidden="true" />,
  'heart':          <Heart       size={24} aria-hidden="true" />,
}

interface FeatureCardProps {
  icon: string
  title: string
  body: string
}

export default function FeatureCard({ icon, title, body }: FeatureCardProps) {
  return (
    <div className="card group text-center hover:border-brand-sky border border-transparent transition-all duration-300">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl2 bg-gradient-to-br from-brand-sky/20 to-brand-blue/10 text-brand-blue mb-4 group-hover:from-brand-blue group-hover:to-brand-navy group-hover:text-white transition-all duration-300">
        {iconMap[icon] ?? <span aria-hidden="true">✦</span>}
      </div>
      <h3 className="text-brand-navy font-display font-bold text-lg mb-2">{title}</h3>
      <p className="text-slate-500 text-sm leading-relaxed">{body}</p>
    </div>
  )
}
